import { CustomVizHookDropdownOptions } from 'apps/sigma2-ui/src/lib/custom-viz/types';

export type PayCorrectionJobLevelInfo = { [key: string]: string };

export type PayCorrectionDepartmentToJobLevelsMap = Record<
  string,
  PayCorrectionJobLevelInfo
>;

/**
 * This hook takes in the dropdown options and returns a map of department to job levels.
 *
 * Example of what the dropdown options look like:
 * dropdownId will be 'department', 'job_level_{job_title}', or 'job_title_{department}'.
 *
 * Using this, we can construct a map of department to job levels.
 *
 * @param dropdownOptions
 */
export const usePayCorrectionDepartmentToJobLevelsMap = ({
  dropdownOptions,
}: {
  dropdownOptions: CustomVizHookDropdownOptions;
}): PayCorrectionDepartmentToJobLevelsMap => {
  // Grab all the department dropdowns since they all use the dropdownId of 'department'.
  const depts = dropdownOptions.filter((o) => {
    return o.dropdownId === 'department';
  });

  const deptToJobLevelsMap: PayCorrectionDepartmentToJobLevelsMap = {};

  for (const dept of depts) {
    const departmentValue = dept.dropdownItemValue;

    const titles = dropdownOptions
      .filter((o) => {
        return o.dropdownId === 'job_title_' + departmentValue;
      })
      .map((o) => {
        return o.dropdownItemValue;
      });

    const allJobLevelInfos: PayCorrectionJobLevelInfo = {};

    for (const title of titles) {
      const jobLevelsForTitle = dropdownOptions.filter((o) => {
        return o.dropdownId === 'job_level_' + title;
      });

      for (const jobLevel of jobLevelsForTitle) {
        allJobLevelInfos[jobLevel.dropdownItemValue] =
          jobLevel.dropdownItemText;
      }
    }

    deptToJobLevelsMap[dept.dropdownItemValue] = allJobLevelInfos;
  }

  return deptToJobLevelsMap;
};
